import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '@core/routes';
import { isAuthenticated } from '@features/auth/store/auth.signals';
import { PublicContextService } from '@features/public/services/public-context.service';

export const listingDetailsAuthGuard: CanActivateFn = route => {
    const router = inject(Router);

    if (isAuthenticated()) {
        return true;
    }

    const context = inject(PublicContextService);
    const id = route.paramMap.get('id');

    context.shareInfo.set(null);
    context.shareError.set(null);

    if (!id || !/^\d+$/.test(id)) {
        return router.createUrlTree(['/']);
    }

    return router.createUrlTree(['/' + APP_ROUTES.PUBLIC_LISTING_DETAILS, id]);
};
